import { render } from "./MyAutocomplete.vue?vue&type=template&id=6b7b9aa7"
import script from "./MyAutocomplete.vue?vue&type=script&lang=js"
export * from "./MyAutocomplete.vue?vue&type=script&lang=js"

import "./MyAutocomplete.vue?vue&type=style&index=0&id=6b7b9aa7&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__